// Shared constants for the DC Ireland application

export const API_ENDPOINTS = {
    EVENTS: '/api/events',
    WEEKLY_DECLARATION: '/api/weekly-declaration',
    MESSAGE_OF_THE_DAY: '/api/message-of-the-day',
    PRAYER_REQUESTS: '/api/prayer-requests',
    TESTIMONIES: '/api/testimonies',
    AMEN_CLICKS: '/api/amen-clicks',
    LOCATIONS: '/api/locations',
    AUTH: '/api/auth',
    UPLOAD: '/api/upload',
} as const;

export const HTTP_STATUS = {
    OK: 200,
    CREATED: 201,
    BAD_REQUEST: 400,
    UNAUTHORIZED: 401,
    FORBIDDEN: 403,
    NOT_FOUND: 404,
    INTERNAL_SERVER_ERROR: 500,
} as const;

export const MAX_HERO_SLIDES = 6;

export * from './seedImages';
export * from './chapters';
export * from './counties';

